<template>
  <!-- 直播分享 -->
  <div class="live_share">
    <van-overlay :show="showHint" z-index="10003" @touchmove.prevent.stop >
      <div   >
        <div class="fenxiang1">
          <img src="@/assets/img/fenxiang1.png" >
        </div>
        <div class="fenxiang2">
          <img src="@/assets/img/fenxiang2.png"  @click="showHint=false">
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "live-share",
  data() {
    return {
      show: false,
      showHint: false, //提示
    };
  },
  computed: {},
  created() {
    this.getConfig();
  },
  mounted(){
  },
  methods: {
    ...mapActions({
      getConfig:"wxShare/getConfig"
    }),
    //打开分享模态框
    open() {
      this.showHint = true;
    }
  },
}
</script>

<style scoped lang="scss">
/* 直播分享 */
.live_share {
  position: relative;
  .live_share_tip {
    z-index: 3000;
  }
  .share_dialog {
    height: 3rem;
    overflow: initial;
    border-radius: 0.15rem 0.15rem 0 0;
    .van-action-sheet__cancel {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 0.9rem;
      line-height: 0.9rem;
      font-size: 0.26rem;
      &::before {
        height:0.02rem;
        background: #e5e5e5;
      }
    }
    .share_content {
      display: flex;
      height: 2.1rem;
      padding: 0.45rem 0.7rem 0;
      justify-content: space-between;
      position: relative;
      .item {
        width: 1.2rem;
        img {
          height: 1rem;
          width: 1rem;
          display: block;
          margin: 0 auto;
        }
        p {
          text-align: center;
          margin-top: 0.1rem;
        }
      }
      .share_ewm {
        position: absolute;
        left: 50%;
        top: -1.2rem;
        text-align: center;
        transform: translateX(-50%);
        .ewm_img {
          width: 2.4rem;
          height: 2.4rem;
          background: #fff;
          padding: 0.17rem;
          border-radius: 0.08rem;
          overflow: hidden;
          margin-bottom: 0.4rem;
          box-shadow: 0px 1px 0.2rem 0.02rem rgba(0, 0, 0, 0.1);
          &::v-deep img {
            width: 100%;
            height: 100%;
          }
        }
        
        p {
          line-height: 1;
          color: #fd494b;
        }
      }
    }
  }
  &_tip {
    position: fixed;
    z-index: 2020;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    .tip {
      width: 6rem;
      margin-top: 1rem;
    }
    .btn {
      margin-top: 1.5rem;
      width: 2.55rem;
    }
  }
}
.fenxiang1{
  margin-top: 1.54rem;
  margin-left: 1.64rem;
  img{
    width: 4.58rem;
    height: 2.43rem;
  }
}
.fenxiang2{
  margin-top: 1.23rem;
  img{
    width:2.6rem;
    height: 0.78rem;
    margin-left: 2.46rem
  }
}
</style>
